export default __webpack_public_path__ + "static/air-banner-02-bg-B-aa0b96c844f44f172269fdcbbdc32d0d.png";